module.exports = __webpack_public_path__ + "img/market.ed4fbfbe.png";